module.exports = __webpack_public_path__ + "img/banner_ssc_yf.647407b6.jpg";